module.exports = __webpack_public_path__ + "img/client_hhnk.df8a9783.png";